<div class="name-table__icons" *ngIf="product?.markers">
  <div *ngFor="let marker of product.markers" class="item">
    <a [nbTooltip]="marker.header" class="{{marker.icon}}"></a>
  </div>
</div>
